// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3t2i8","additionalInfo":"AgreementModal_additionalInfo__1oUq-"};